/**
 * Utilitaires généraux pour l'application Sphere
 * Contient des fonctions helper communes utilisées dans les composants
 */

import { type ClassValue, clsx } from 'clsx'

/**
 * Fonction utilitaire pour merger les classes CSS
 * Utilise clsx pour gérer intelligemment les conditions de classes
 *
 * @param inputs - Classes CSS à merger (strings, arrays, objects, etc.)
 * @returns String de classes CSS optimisée
 *
 * @example
 * ```tsx
 * cn('px-2 py-1', 'bg-red-500', { 'active': isActive })
 * // => 'px-2 py-1 bg-red-500 active' (si isActive est true)
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
